import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import { useOrchestrator } from '@/hooks'
import { stepToComponentMap } from '@/stepMappings'
import StepHeader from '@/components/StepHeader/StepHeader'
import SimpleStepper from '@/components/SimpleStepper'
import appStyles from '@/App.module.scss'
import { getFeatureFlags, Loading } from '@/components'
import { useConfig } from '@/redux/partnerConfig/selectors'
import { useCTAs, useOidcRegistration } from '@/redux/productConfig/selectors'
import messages from './pages/SummaryPage.messages'

interface Props {
  stepSlug: string
}

const Step = ({ stepSlug }: Props) => {
  const {
    activeStepIndex,
    stepLabels,
    pageContent,
    pageComponentName,
  } = useOrchestrator({ stepSlug })
  const devOidcEnabled = getFeatureFlags().oidc_enabled
  const oidcEnabled = useOidcRegistration()
  const componentMap = stepToComponentMap(!!oidcEnabled || !!devOidcEnabled)
  const Component = componentMap[pageComponentName]
  const { useDnaV2Design } = useConfig()
  const showBookCTA = useCTAs()?.includes('book_appointment')
  const translate = useFormatMessage()

  // TODO: Improve check
  if (activeStepIndex === undefined) {
    return <Loading />
  }

  let { title, copy } = pageContent

  const isSummary = pageComponentName === 'summary'
  const dynamicClassName =
    isSummary && useDnaV2Design
      ? `${appStyles.StepContent} ${appStyles.StepContent}--useDnaV2Design`
      : `${appStyles.StepContent}`

  if (showBookCTA && isSummary) {
    title = translate(messages.stepTitle)
    copy = []
  }

  return (
    <>
      {useDnaV2Design ? (
        <SimpleStepper
          activeStep={activeStepIndex}
          steps={stepLabels}
          pageTitle={title}
          content={copy as string[]}
          dynamicClassName={dynamicClassName}
        />
      ) : (
        <StepHeader
          activeStep={activeStepIndex}
          steps={stepLabels}
          pageTitle={title}
          content={copy as string[]}
        />
      )}
      <div className={dynamicClassName}>
        <Component />
      </div>
    </>
  )
}

export default Step
